var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/placeholder/components/placeholder_display_name.tsx";
import React from 'react';
import { randomIntFromInterval, generateText } from '../utils';
/** Fake display name to show when data is loading. */
const PlaceholderDisplayName = ({
  minLength,
  maxLength
}) => {
  const length = randomIntFromInterval(maxLength, minLength);
  const acctLength = randomIntFromInterval(maxLength, minLength);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col text-slate-200 dark:text-slate-700",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("p", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }, generateText(length)), /*#__PURE__*/React.createElement("p", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 7
    }
  }, generateText(acctLength)));
};
export default PlaceholderDisplayName;